/*
  Kiwi Ears · header contrast switch (Rene 2026-08-21).

  Only runs when the header is in transparent-overlay mode. Any element that
  carries data-nav-theme="dark" declares "the bar is unreadable over me" — while
  one of those sits under the bar, #siteNav gets .nav-dark and the logo (plus the
  mobile burger) flips to white. Sections opt in with a single attribute on their
  root element; nothing else needs to know about the header.

  ScrollTrigger drives it so the probe stays in step with Lenis (per CLAUDE.md);
  a rAF-throttled scroll listener covers the no-GSAP case.
*/
(function () {
  var nav = document.getElementById('siteNav');
  if (!nav || nav.getAttribute('data-bar') !== 'overlay') return;

  var marks = [].slice.call(document.querySelectorAll('[data-nav-theme="dark"]'));
  if (!marks.length) return;

  /* the line we sample: the middle of the bar row, in viewport coordinates */
  function probe() {
    var row = nav.firstElementChild;
    var h = (row || nav).getBoundingClientRect().height || 72;
    return Math.round(h / 2);
  }

  var dark = [];
  function apply() {
    nav.classList.toggle('nav-dark', dark.length > 0);
  }
  function mark(el, on) {
    var i = dark.indexOf(el);
    if (on && i < 0) dark.push(el);
    else if (!on && i > -1) dark.splice(i, 1);
    apply();
  }

  if (window.gsap && window.ScrollTrigger) {
    var triggers = marks.map(function (el) {
      return window.ScrollTrigger.create({
        trigger: el,
        start: function () { return 'top ' + probe() + 'px'; },
        end: function () { return 'bottom ' + probe() + 'px'; },
        onToggle: function (self) { mark(el, self.isActive); }
      });
    });
    /* onToggle only fires on a CHANGE, so a trigger that is already active at
       scroll 0 — a dark hero at the top of the page — never reports itself.
       Sync explicitly after creation and after every refresh. */
    function sync() {
      triggers.forEach(function (t) { mark(t.trigger, t.isActive); });
    }
    sync();
    window.ScrollTrigger.addEventListener('refresh', sync);
    /* the bar changes height across breakpoints — re-measure with everything else */
    window.addEventListener('resize', function () { window.ScrollTrigger.refresh(); });
    /* late webfonts and images move things; one more pass once everything lands */
    window.addEventListener('load', function () { window.ScrollTrigger.refresh(); });
    return;
  }

  /* fallback: same containment test, once per frame */
  var queued = false;
  function scan() {
    queued = false;
    var y = probe();
    marks.forEach(function (el) {
      var r = el.getBoundingClientRect();
      mark(el, r.top <= y && r.bottom > y);
    });
  }
  function tick() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(scan);
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);
  window.addEventListener('load', scan);
  scan();
})();
